"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanseJapaneseAndRoman = cleanseJapaneseAndRoman;
exports["default"] = japaneseAndRoman;
exports.romanOnly = romanOnly;
// Romanji = a-zA-Z
// Hiragana = \u3040-\u309F
// Katakana = \u30A0-\u30FF
// Half Width Katakana = \uFF00-\uFFEF
// Common and uncommon kanji = \u4E00-\u9FAF
// To avoid input issues, romanji and half width katakana is required.
// White space = \x20
// Apostrophe = \x27
var ROMAN_REGEX = /^(?!\.)[a-zA-Z\d\x20\x27.-]*[a-zA-Z\d\x20\x27.-]+(\.*)$/;
var VALID_ROMAN_JAPANESE_REGEX = /^[a-zA-Z\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u3001-\u303F\u005F\u0023\u002B-\u0040\x20\x27-\d-\d]+$/; // Select non-valid japanese or roman characters

var INVALID_ROMAN_JAPANESE_REGEX = /[^a-zA-Z\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u3001-\u303F\u005F\u0023\u002B-\u0040\x20\x27-\d-\d]+/g;

function validRoman(text) {
  return ROMAN_REGEX.test(text);
} // Used to only allow new form values as long as the input value is:
//  a Japanese, or Roman Letter, or White Space, or Apostrophe, or Hyphen


function japaneseAndRoman(value, previousValue) {
  return value === '' || VALID_ROMAN_JAPANESE_REGEX.test(value) ? value : previousValue;
}

function romanOnly(value, previousValue) {
  return value === '' || validRoman(value) ? value : previousValue;
}

function cleanseJapaneseAndRoman(value) {
  if (typeof value !== 'string') {
    return value;
  }

  return value.replaceAll(INVALID_ROMAN_JAPANESE_REGEX, '');
}